async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data.message || `Request failed (${response.status})`);
    err.reasons = data.reasons;
    throw err;
  }
  return data;
}

export async function fetchVehiclePriceEvents(filters = {}) {
  const params = new URLSearchParams();
  if (filters.eventType) params.set("event_type", filters.eventType);
  if (filters.vehicleSourceId) params.set("vehicle_source_id", filters.vehicleSourceId);
  if (filters.sellerType) params.set("seller_type", filters.sellerType);
  if (filters.city) params.set("city", filters.city);
  if (filters.department) params.set("department", filters.department);
  if (filters.make) params.set("make", filters.make);
  if (filters.model) params.set("model", filters.model);
  if (filters.eventFrom) params.set("event_from", filters.eventFrom);
  if (filters.eventTo) params.set("event_to", filters.eventTo);
  if (filters.minDeltaPct != null) params.set("min_delta_pct", String(filters.minDeltaPct));
  if (filters.minDeltaCop != null) params.set("min_delta_cop", String(filters.minDeltaCop));
  if (filters.limit) params.set("limit", String(filters.limit));
  const query = params.toString();
  const data = await requestJson(
    `/api/admin/mobility/vehicle-price-events${query ? `?${query}` : ""}`
  );
  return data.events || [];
}

export async function fetchVehicleListingPriceObservations(listingId) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/price-observations`
  );
  return data;
}

export async function fetchVehicleListingPriceEvents(listingId) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/price-events`
  );
  return data;
}
